import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, Mail, Phone, MapPin, Heart } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-teal-600 text-white">
      {/* Emergency Banner */}
      <div className="bg-amber-100 text-amber-900 py-4 px-4">
        <div className="container-max mx-auto">
          <div className="flex flex-col md:flex-row items-center justify-center gap-4 text-center md:text-left">
            <div className="flex items-center gap-2">
              <Phone className="w-5 h-5" />
              <span className="font-semibold">¿Urgencia de salud mental?</span>
            </div>
            <p className="text-sm">
              Este servicio no atiende emergencias. Si necesitas ayuda inmediata, contacta:
              <a href="tel:600 360 7777" className="font-bold ml-2 hover:underline">
                Salud Responde: 600 360 7777
              </a>
              <span className="mx-2">|</span>
              <a href="tel:*4141" className="font-bold hover:underline">
                Fono Ayuda: *4141
              </a>
            </p>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="container-max mx-auto px-4 md:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center">
                <Shield className="w-5 h-5 text-white" />
              </div>
              <span className="font-heading text-xl font-semibold">
                Anonima<span className="text-sand-200">Mente</span>
              </span>
            </Link>
            <p className="text-teal-100 text-sm leading-relaxed">
              Tu historia, tu confidencialidad. Psicología anónima, profesional y segura desde Chile para el mundo.
            </p>
            <div className="flex items-center gap-2 text-teal-200 text-sm">
              <MapPin className="w-4 h-4" />
              <span>Santiago, Chile</span>
            </div>
          </div>

          {/* Para Personas */}
          <div>
            <h4 className="font-heading text-lg font-semibold mb-4">Para Personas</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/personas" className="text-teal-100 hover:text-white transition-colors text-sm">
                  Cómo funciona
                </Link>
              </li>
              <li>
                <Link to="/profesionales" className="text-teal-100 hover:text-white transition-colors text-sm">
                  Nuestros profesionales
                </Link>
              </li>
              <li>
                <Link to="/agendar" className="text-teal-100 hover:text-white transition-colors text-sm">
                  Agendar sesión
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-teal-100 hover:text-white transition-colors text-sm">
                  Preguntas frecuentes
                </Link>
              </li>
            </ul>
          </div>

          {/* Para Empresas */}
          <div>
            <h4 className="font-heading text-lg font-semibold mb-4">Para Empresas</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/empresas" className="text-teal-100 hover:text-white transition-colors text-sm">
                  Programa EAP Anónimo
                </Link>
              </li>
              <li>
                <Link to="/empresas#planes" className="text-teal-100 hover:text-white transition-colors text-sm">
                  Planes y precios
                </Link>
              </li>
              <li>
                <Link to="/contacto" className="text-teal-100 hover:text-white transition-colors text-sm">
                  Solicitar demo
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-teal-100 hover:text-white transition-colors text-sm">
                  Blog corporativo
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-heading text-lg font-semibold mb-4">Legal</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/legales/terminos" className="text-teal-100 hover:text-white transition-colors text-sm">
                  Términos y condiciones
                </Link>
              </li>
              <li>
                <Link to="/legales/privacidad" className="text-teal-100 hover:text-white transition-colors text-sm">
                  Política de privacidad
                </Link>
              </li>
              <li>
                <Link to="/legales/consentimiento" className="text-teal-100 hover:text-white transition-colors text-sm">
                  Consentimiento informado
                </Link>
              </li>
              <li>
                <Link to="/contacto" className="text-teal-100 hover:text-white transition-colors text-sm">
                  Contacto
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-teal-500">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-teal-200 text-sm">
              © {currentYear} AnonimaMente. Todos los derechos reservados.
            </p>
            <p className="text-teal-200 text-sm flex items-center gap-1">
              Hecho con <Heart className="w-4 h-4 text-red-400" /> en Chile
            </p>
            <div className="flex items-center gap-4">
              <a 
                href="mailto:[email@anonimamente.cl]" 
                className="text-teal-200 hover:text-white transition-colors"
                aria-label="Email"
              >
                <Mail className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
